import React from 'react';
import PropTypes from 'prop-types';
import { clsx, withSpacing } from '@wds/utils';
import { useTheme } from 'react-jss';

import useStyles from './useStyles';

const Card = ({
  children,
  selected,
  title,
  padding,
  addOn,
  interactive,
  noRule,
  className,
  ...rest
}) => {
  const theme = useTheme();
  const classes = useStyles({ selected, theme, noRule, interactive });
  const classNames = clsx(className, classes.wdsCard);
  const cardAddon = <div className={classes.wdsCardAddon}>{addOn}</div>;
  const hadAddOn = !title && addOn && cardAddon;

  return (
    <div className={classNames} {...rest}>
      <If condition={title}>
        <header className={classes.wdsCardHeader}>
          {title}
          {addOn && cardAddon}
        </header>
      </If>
      <Choose>
        <When condition={padding}>
          <div className={classes.wdsCardBody}>
            {hadAddOn}
            {children}
          </div>
        </When>
        <Otherwise>
          <>
            {hadAddOn}
            {children}
          </>
        </Otherwise>
      </Choose>
    </div>
  );
};

Card.propTypes = {
  /**
   * Custom right side addon, can be text or components.
   */
  addOn: PropTypes.node,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  /**
   * Enable hover styles.
   */
  interactive: PropTypes.bool,
  /**
   * 'Set visibility of divider line.',
   */
  noRule: PropTypes.bool,
  /**
   * Card has built in padding for it&apo;s content but can be turned off.
   */
  padding: PropTypes.bool,
  /**
   * Enable selected card outline.
   */
  selected: PropTypes.bool,
  /**
   * Top section of Card with text title,
   */
  title: PropTypes.node,
};

Card.defaultProps = {
  addOn: undefined,
  className: undefined,
  interactive: false,
  noRule: false,
  padding: true,
  selected: false,
  title: undefined,
};

export default withSpacing(Card);
